import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Parcela } from 'src/app/base/domain/parcela.model';

@Component({
  selector: 'app-alterar-valor-parcela',
  templateUrl: './alterar-valor-parcela.component.html',
  styleUrls: ['./alterar-valor-parcela.component.css']
})
export class AlterarValorParcelaComponent implements OnInit {

  parcelas: Parcela[] = [];
  parcelaSelecionada: Parcela | null = null;

  novaData: Date | null = null;
  novoValor: number = 0;

  constructor(
    public dialogRef: MatDialogRef<AlterarValorParcelaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.parcelas = data.parcelas; // Recebe lista do pai
  }

  ngOnInit(): void {

  }

  onSelectParcela() {
    this.novaData = new Date(this.parcelaSelecionada.dataVencimento);
    this.novoValor = this.parcelaSelecionada.valor;
  }

  onCancel() {
    this.dialogRef.close();
  }

  onConfirm() {
    this.dialogRef.close({
      parcelaId: this.parcelaSelecionada.id,
      novoValor: this.novoValor
    });
  }
}
